import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {LoadingService} from '../../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {ViewEncapsulation} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['assign-recycle-form.component.scss'],
  templateUrl: 'assign-recycle-form.component.html'
})
export class AssingRecycleFormComponent implements OnInit {
  public selection: SelectionModel<any>;
  public title: string;
  public displayedColumns: string [];
  public userRouted: number;
  public dataSource: MatTableDataSource<any>;
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<AssingRecycleFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = 'Ανάθεση Εντολής Ανακύκλωσης';
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource = new MatTableDataSource<any>(this.data.users);
    this.displayedColumns = ['select', 'id', 'username'];
    this.selection = new SelectionModel<any>(true, []);
    this.userRouted = this.data.userRouted;
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('500');
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.data.forEach((row) => {
      if (row.id === this.userRouted) {
        this.selection.select(row);
      }
    });

  }

  closeDialog() {
    this.matDialogRef.close();
  }

  isUserInvalid() {
    return this.selection.selected.length === 0;
  }

  public applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  updateUser() {
    this.matDialogRef.close({success: true, user_id: this.selection.selected[0].id, id: +this.data.recycleCommandId});
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    // @ts-ignore
    const numRows = this.dataSource.data.length;

    return numSelected === numRows;
  }

  selectRow() {
    this.selection.clear();
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }
}
